import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { shortageStatusIconMap } from 'src/app/defaults/product.defaults';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ShortageStatusAvailabilityPipe } from 'src/app/entities/products/pipes/shortage-status-availability.pipe';

import { IShortageStatus } from '../../state/product.model';
import { ShortageStatus } from '../../enums/shortage-status.enum';

@Component({
  standalone: true,
  selector: 'sandoz-product-status-icon',
  templateUrl: './product-status-icon.component.html',
  styleUrls: ['./product-status-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,

    ShortageStatusAvailabilityPipe,

    MatIconModule,
    MatButtonModule,
  ],
})
export class ProductStatusIconComponent {
  private _size: 'small' | 'big' = 'big';
  private _status!: IShortageStatus['id'];
  private _featured: boolean = false;

  readonly ShortageStatus = ShortageStatus;
  readonly shortageStatusIconMap = shortageStatusIconMap;

  @Input()
  set size(v: 'small' | 'big') {
    this._size = v;
  }
  get size(): 'small' | 'big' {
    return this._size;
  }

  @Input({ required: true })
  set status(v: IShortageStatus['id']) {
    this._status = v;
  }
  get status(): ShortageStatus {
    return this._status;
  }

  @Input()
  set featured(v: boolean) {
    this._featured = v;
  }
  get featured(): boolean {
    return this._featured;
  }
}
